import { colors } from "./colors_v2.js";
import { utilsApp } from "./utils-app_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { dateTimeUtils } from "./dateTimeUtils_v2.js";
import { identityService } from "./profile/identityService_v2.js";

var helpState = {
  size: "small",
  helpIndex: 0,
  helpContentTab: "",
};

const getSize = () => {
  return helpState.size;
};

const render = (size) => {
  const helpNav = document.getElementById("helpNav");
  helpNav.classList.add("sectionNarrow");
  const helpSection = document.getElementById("helpSection");
  switch (size) {
    case "normal":
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "modalBehinderHelpClose";
      // modalBehinder.addEventListener("click", close);
      helpState.size = "normal";
      helpSection.style.width = utilsApp.calculateSectionWidth();
      const htmlNormal = `
        <div id="sectionHeaderArea" class="vertical">
          <div id="helpvert">Help</div>
        </div>
        <div id="rightColumn">
          <div id="subNavContainer">
            <button id="how2" class="helpSubNav">
              How To Play
            </button>
            <button id="strategy" class="helpSubNav">
              Strategy
            </button>
            <button id="policies" class="helpSubNav">
              Policies
            </button>
            <button id="about" class="helpSubNav">
              About
            </button>
            <button id="appStats" class="helpSubNav">
              App Stats
            </button>
          </div>

          <div id="helpContent">
          </div>
        </div>
        <div id="closeHelpSection" class = "x"></div>
        `;
      helpSection.innerHTML = htmlNormal;
      helpSection.classList.add("sectionWide");
      helpSection.classList.add("helpSection");
      helpContent.style.borderColor = colors.getGameColor("hexGrid");
      // addEventListeners();
      handleHelpTab({ target: { id: "how2" } }); //default
      utilsApp.adjust4Mobile();
      break;
    case "small":
      helpState.size = "small";
      helpSection.style.width = "0px";
      helpSection.innerHTML = "";
      helpSection.className = "";
      break;
    default:
      console.log("Error: Attempting to render help to invalid size: " + size);
      return;
  }
  colors.setNavColors();
  colors.setButtonColors();
  helpSection.style.borderColor = colors.getGameColor("hexGrid");
  helpNav.style.borderColor = colors.getGameColor("hexGrid");
};

const close = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const handleHelpNavClick = () => {
  render("normal");
};

const handleHelpTab = async (event) => {
  const gotClicked = event.target.id;
  let html;
  switch (gotClicked) {
    case "how2":
      helpState.helpIndex = 0;
      helpState.helpContentTab = "how2";
      html = getHow2Html(helpState.helpIndex);
      break;
    case "strategy":
      helpState.helpIndex = 0;
      helpState.helpContentTab = "strategy";
      html = getStrategyHtml(helpState.helpIndex);
      break;
    case "policies":
      helpState.helpContentTab = "policies";
      html = `
      <p>Privacy Policy:</p> 
      <p>We won't sell your email or other personal data. We may use Google Analytics, Google Captchas, and/or other such services that may track 
      you. You'll have to ask them what they do with it. While unlikely, it's possible someone may way want to buy this site in the future. If that happens, 
      you'll have to ask them if this policy might change.</p>
      <p> Terms of Use:</p>
      <p>You are over 18, or you have direct permission and supervison of a parent or legal guardian.</p>
      <p>Limitation of Liability: We will not be liable for any actions, claims, losses, damages, liabilities 
      and expenses including legal fees from your use of the Site.</p>
      <p>Indemnity: Except where prohibited by law, by using this Site you indemnify and hold us harmless from any actions, 
      claims, losses, damages, liabilities and expenses including legal fees arising out of your use of our 
      Site or your violation of these Terms of Use.</p>
      <p>Applicable Law: These Terms of Use are governed by the laws of the State of Texas.</p>
      `;
      break;
    case "about":
      helpState.helpContentTab = "about";
      html = `
      <p>Togagon was created by Jay Garing with the kind assistance of a few fellow lovers of two person combinatorial games with perfect knowledge. </p>
      <p>Got feedback? Send an email to jay.garing@topagon.com. I'll check it sometimes.</p>
      <div id="wartbrandt"></div>
      `;
      break;
    case "appStats":
      helpState.helpContentTab = "appStats";
      html = await getAppStatsHTML();
      break;
  }
  renderHelpContent(html);
};

const renderHelpContent = (html) => {
  const helpContent = document.getElementById("helpContent");
  helpContent.innerHTML = html;
  // Next/Previous clicks are handled by eventHub (registered at the bottom of this file)
  if (document.getElementById("helpNext")) {
    colors.setButtonColors();
  }
  setSelected();
};

const setSelected = () => {
  const tabs = ["how2", "strategy", "policies", "about", "appStats"];
  const activeTab = helpState.helpContentTab;

  tabs.forEach((tabId) => {
    const element = document.getElementById(tabId);

    if (element) {
      if (tabId === activeTab) {
        element.classList.add("selected");
      } else {
        element.classList.remove("selected");
      }
    }
  });
};

const handleNext = () => {
  const max =
    helpState.helpContentTab === "strategy"
      ? strategyItems.length
      : how2Items.length;
  if (helpState.helpIndex < max - 1) {
    helpState.helpIndex++;
  }
  renderHelpContent(getHelpContentHtml());
};

const handlePrevious = () => {
  if (helpState.helpIndex >= 1) {
    helpState.helpIndex--;
  }
  renderHelpContent(getHelpContentHtml());
};

const getHelpContentHtml = () => {
  return helpState.helpContentTab === "strategy"
    ? getStrategyHtml(helpState.helpIndex)
    : getHow2Html(helpState.helpIndex);
};

const how2Items = [
  `<h3>Players take turns:</h3><ul>
        <li class="helpLi">On your turn, you can either Add, Rotate, or Remove.</li>
         <li class="helpLi">Click and hold to choose the direction.</li></ul>
    <h3>TLDR:</h3>
      <ul>
        <li class="helpLi">This game is different: You don't add pieces on empty places, except the middle.</li>
        <li class="helpLi">Instead, add them on top existing pieces (which move out of the way if they can).</li>
        <li class="helpLi">Earn points by keeping your pieces together.</li>
        <li class="helpLi">Click next to learn more.</li>
      </ul><div id="how2-1"></div>`,
  `<h3>Rules for Adding a piece:</h3> 
        <ul>
          <li class="helpLi">You can't add a piece on an empty place, except the four in the middle.</li>
          <li class="helpLi">Add a new piece on top of any existing piece that is not blocked.</li> 
          <li class="helpLi">The underneath piece moves out of the way in the direction it's facing, unless it's blocked.</li>
          <li class="helpLi">A chain of pieces will move out of the way, unless the last piece is blocked.</li>
        </ul>`,
  ` <h3>Rules for Rotating a piece:</h3> 
          <ul>
            <li class="helpLi">You can only rotate your own pieces.</li>
            <li class="helpLi">The new direction can't be blocked.</li>
          </ul>`,
  ` <h3>Rules for Removing a piece:</h3> 
          <ul>
            <li class="helpLi">You can remove any piece.</li>
            <li class="helpLi">The player going first can remove two.</li>
            <li class="helpLi">The player going second can remove three, which offsets the advantange of going first.</li>
          </ul>`,
  ` <h3>Rules for when a piece is blocked:</h3>
          <ul>
            <li class="helpLi"">It is pointing to the edge.</li>
            <li class="helpLi">It is pointing to a piece that is pointing back at it.</li> 
            <li class="helpLi">A chain of pieces points back to itself.</li>
          </ul>`,
  ` <h3>Winning:</h3>
        <ul>
        <li class="helpLi">The match is over when one player can not add or rotate.</li>
        <li class="helpLi">This is true even if they happen to have removes they haven't used yet.</li>
        <li class="helpLi">Highest points wins.</li></ul>
    <h3>Scoring:</h3><ul><li class="helpLi">The point value of a piece depends on the 
        number of sides it shares with your other pieces.</li>
        <li class="helpLi">An isolated piece is worth zero. Each additional 
        shared side adds one point. </li>
        </ul>`,
];

const strategyItems = [
  `<h3>Add before rotate:</h3><ul><li class="helpLi">If you rotate, but your opponent adds, 
        they will have more pieces on the board than you.</li></ul>`,
  `<h3>Pretzel Fighting:</h3><ul><li class="helpLi">Get in the middle 
        of everything your opponent does. Break up their groups. </li></ul>
  <h3>Lock the Board:</h3><ul>
        <li class="helpLi">If you leave them with no place to add, they have to rotate or remove.</li>
        <li class="helpLi">They are also trying to leave you without a place to add, but you can preempt them. Make sure they can't lock the board by pointing your piece to open area with at least two open places.</li>
        </ul>`,
  `<h3>Be the Second Mouse:</h3><ul><li class="helpLi">Opening strategy means building your base and pre-positioning for strategic spots.</li>
        <li class="helpLi">Let your opponent push you into them.</li>
        <li class="helpLi">The second mouse gets the cheese.</li></ul>`,
  `<h3>Think Ahead:</h3><ul><li class="helpLi">As the game progresses, there will be more and 
        more rotating and removing going on. </li><li class="helpLi">Don't let these kind of moves inadvertently unblock entire chains you didn't consider.</li></ul>`,
  `<h3>Patience:</h3><ul><li class="helpLi">As you near the end, there will be fewer valid moves.</li>
    <li class="helpLi">Use this fact to force your opponent to help you.</li>
    <li class="helpLi">Set them up so that their only move is to push you onto the double...</li></ul>
    <h3>Removes:</h3> 
      <ul>
        <li class="helpLi">Of all the possible pieces to remove, the best choice leaves the board locked for your opponent.</li>
        <li class="helpLi">End game momentum means your opponent is going to be increasingly successful at locking the board. If they are forcing you to rotate move after move, you can get out of it by removing instead of rotating. But only for a while. Make the removes count.</li>
        <li class="helpLi">If you keep losing control of the end game, read the above point again.</li>
      </ul>`,
  `<h3>Retrograde Thinking:</h3><ul><li class="helpLi">Intentionally lower your score if it lowers your opponent's score more. 
        <Li class="helpLi">Jay's Law: What matters is having more points than your opponent.</li> 
        <li class="helpLi">Corollary to Jay's Law: A win is a win. It doesn't matter by how much. </li>
       `,
];

const previousNextButtonsHtml = () => {
  return `<div id="previousNext">
        <button id="helpPrevious">Previous</button>
        <button id="helpNext">Next</button>  (${helpState.helpIndex + 1} of ${
          helpState.helpContentTab === "strategy"
            ? strategyItems.length
            : how2Items.length
        })
      </div>`;
};

const getStrategyHtml = (index) => {
  return `${previousNextButtonsHtml()}${strategyItems[index]}`;
};

const getHow2Html = (index) => {
  return `${previousNextButtonsHtml()}${how2Items[index]}`;
};

const getAppStatsHTML = async () => {
  const beginsWith = `${dateTimeUtils.year()}-${dateTimeUtils.month()}`;
  const grouping = "day";
  let html = "";
  const result = await identityService.getAppStats({ beginsWith, grouping });
  if (result.status != 200) {
    const message = result?.message ?? "";
    html = "Sorry about this. Error retrieving the data. " + result.message;
    return html;
  }
  const appStats = result?.appStats ?? [];
  html += `<div id="appStatsContainer" class="flexColumn">`;
  html += `<div id="appStatsHeader">Matches Played:</div>`;

  for (const row of appStats) {
    html += `<div class="appStatsRow">${row.sk}: ${row?.matchesFinished ?? 0}</div>`;
  }
  html += `</div>`;

  return html;
};

eventHub.registerEvent("click", "modalBehinderHelpClose", close);
eventHub.registerEvent("click", "helpNav", handleHelpNavClick);
eventHub.registerEvent("click", "closeHelpSection", close);
eventHub.registerEvent("click", "how2", handleHelpTab);
eventHub.registerEvent("click", "about", handleHelpTab);
eventHub.registerEvent("click", "strategy", handleHelpTab);
eventHub.registerEvent("click", "policies", handleHelpTab);
eventHub.registerEvent("click", "appStats", handleHelpTab);
eventHub.registerEvent("click", "helpNext", handleNext);
eventHub.registerEvent("click", "helpPrevious", handlePrevious);

export const help = {
  render,
  getSize,
};
